const availableActionsConfig = {
  "edit": true,
  "delete": true
}

export default availableActionsConfig;